"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.normalizePathSep = normalizePathSep;
function normalizePathSep(path) {
    return path.replace(/\\/g, '/');
}

//# sourceMappingURL=normalize-path-sep.js.map